function errorText(error) {
  return [
    error?.code,
    error?.message,
    error?.details,
    error?.hint,
  ].filter(Boolean).join(' ').toLowerCase();
}

export function getPublicErrorKey(error) {
  const text = errorText(error);

  if (/phone|quote_requests_phone_valid|international customer phone/.test(text)) return 'phone';
  if (/email.*invalid|invalid.*email|customer_email/.test(text)) return 'email';
  if (/customer_name|valid customer name/.test(text)) return 'name';
  if (/quantity|quote quantity/.test(text)) return 'quantity';
  if (/quote_upload_failed|design files could not be uploaded|storage/.test(text)) return 'upload';
  if (/invalid login credentials|invalid_credentials/.test(text)) return 'invalidLogin';
  if (/already registered|already exists|user_already_exists/.test(text)) return 'accountExists';
  if (/rate limit|too many requests|over_email_send_rate_limit/.test(text)) return 'rateLimit';
  if (/failed to fetch|network|fetcherror|connection/.test(text)) return 'network';

  return 'unknown';
}

export function getPublicErrorMessage(error, messages, fallback) {
  return messages[getPublicErrorKey(error)] || fallback;
}
